import _ from 'lodash';
import * as types from './types';
import { UPDATE_STUDENT } from 'PointOfSale/state/types';

export const INITIAL_STATE = {
  teacher: '',
  students: [],
  numProcessed: 0,
  numProcessing: 0,
  loading: false,
  writing: false,
  error: null,
  selectAllStudents: false,
};

export default (state = INITIAL_STATE, { type, payload }) => {
  switch (type) {
    case UPDATE_STUDENT:
      return {
        ...state,
        students: state.students.map(student => {
          if (student.IdSeed === payload.idSeed) {
            return {
              ...student,
              ...payload.update,
            };
          }
          return student;
        }),
      };
    case types.SET_SELECT_ALL_STUDENTS:
      return {
        ...state,
        selectAllStudents: payload,
      };
    case types.SET_NUM_PROCESSED:
      return {
        ...state,
        numProcessed: payload,
      };
    case types.SET_NUM_PROCESSING:
      return {
        ...state,
        numProcessing: payload,
      };
    case types.SET_TEACHER:
      return {
        ...state,
        teacher: payload,
        selectAllStudents: false,
      };
    case types.SET_STUDENTS:
      return {
        ...state,
        students: _.cloneDeep(payload),
      };
    case types.REMOVE_STUDENT:
      return {
        ...state,
        students: state.students.filter(s => s.IdSeed !== payload),
      };
    case types.SET_LOADING:
      return {
        ...state,
        loading: payload,
      };
    case types.SET_WRITING:
      return {
        ...state,
        writing: payload,
      };
    case types.SET_ERROR:
      return {
        ...state,
        error: payload,
      };
    case types.TOGGLE_FOR_CHECKOUT:
      return {
        ...state,
        students: state.students.map(s => ({
          ...s,
          selected: payload.students.includes(s.IdSeed)
            ? payload.selected
            : s.selected,
        })),
      };
    case types.RESET:
      return {
        ...state,
        teacher: '',
        students: [],
        loading: false,
        error: null,
        numProcessed: 0,
        numProcessing: 0,
      };
    case types.SET_STUDENT_ERROR:
      return {
        ...state,
        students: state.students.map(student => {
          if (student.IdSeed === payload.idSeed) {
            return {
              ...student,
              error: payload.error,
            };
          }
          return student;
        }),
      };
    case types.RESET_STUDENT_ERROR:
      return {
        ...state,
        students: state.students.map(student => {
          if (student.IdSeed === payload.idSeed) {
            return {
              ...student,
              error: null,
            };
          }
          return student;
        }),
      };
    case types.RESET_ALL_STUDENTS_BOUGHT_ITEMS:
      return {
        ...state,
        students: state.students.map(student => ({
          ...student,
          BoughtItems: [],
        })),
      };
    case types.RESET_ALL_STUDENTS_SELECTED:
      return {
        ...state,
        students: state.students.map(student => ({
          ...student,
          selected: false,
        })),
      };
    case types.RESET_ALL_STUDENTS_ERROR:
      return {
        ...state,
        students: state.students.map(student => ({
          ...student,
          error: null,
        })),
      };
    case types.RESET_STUDENT_BOUGHT_ITEMS:
      return {
        ...state,
        students: state.students.map(student => {
          if (student.IdSeed === payload) {
            return {
              ...student,
              BoughtItems: [],
            };
          }
          return student;
        }),
      };

    case types.RESET_STUDENT_SELECTED:
      return {
        ...state,
        students: state.students.map(student => {
          if (student.IdSeed === payload) {
            return {
              ...student,
              selected: false,
            };
          }
          return student;
        }),
      };

    case types.ADD_ITEM: {
      return {
        ...state,
        students: state.students.map(student => {
          if (student.IdSeed === payload.idSeed) {
            const foundIndex = student.BoughtItems.findIndex(
              item => item.ItemId === payload.item.ItemId
            );

            const BoughtItems = [...student.BoughtItems];
            if (foundIndex === -1) {
              BoughtItems.push({ ...payload.item, Qty: 1 });
            } else {
              const path = ['BoughtItems', foundIndex, 'Qty'];
              _.set(student, path, _.get(student, path, 0) + 1);
            }
            return {
              ...student,
              BoughtItems,
            };
          }
          return student;
        }),
      };
    }
    case types.ADD_ITEM_TO_STUDENTS: {
      return {
        ...state,
        students: state.students.map(student => {
          if (payload.students.includes(student.IdSeed)) {
            const foundIndex = student.BoughtItems.findIndex(
              item => item.ItemId === payload.item.ItemId
            );

            const BoughtItems = [...student.BoughtItems];
            if (foundIndex === -1) {
              BoughtItems.push({ ...payload.item, Qty: 1 });
            } else {
              const path = ['BoughtItems', foundIndex, 'Qty'];
              _.set(student, path, _.get(student, path, 0) + 1);
            }
            return {
              ...student,
              BoughtItems,
            };
          }
          return student;
        }),
      };
    }
    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./src/pages/pointofsale/modules/teacher/state/reducer.js